<template>
    <div class="bot-center">
        <h1 class="text-center bot-color-blue">Đăng nhập</h1>
        <bot-spinner v-model="spinner">
            <template>
                <v-form
                    v-model="isValid"
                    ref="form"
                    @keyup.native.enter="submit"
                    @submit.prevent="submit"
                >
                    <v-text-field
                        label="Email"
                        autofocus
                        v-model="values.Email"
                        :rules="[(value) => vld.email(value)]"
                    ></v-text-field>
                    <v-text-field
                        type="password"
                        v-model="values.Password"
                        :rules="[
                            (value) =>
                                vld.text({
                                    field: 'mật khẩu',
                                    value,
                                }),
                        ]"
                        label="Password"
                    ></v-text-field>
                    <v-btn color="primary" @click="submit">Ok</v-btn>
                </v-form>
            </template>
        </bot-spinner>
    </div>
</template>

<script>
import BotSpinner from "@/components/bot/spinner/bot.spinner.vue";
const cafe = {
    sms: {
        success: "Đăng nhập thành công!",
    },
};

export default {
    name: "Login",

    components: {
        "bot-spinner": BotSpinner,
    },

    // this is state
    data() {
        return {
            isValid: false,
            vld: this.$options.filters.validate,
            spinner: {
                visible: false,
                color: "red",
            },
            values: {
                Email: null,
                Password: null,
                IP: null,
            },
        };
    },

    mounted() {
        const ua = this.$store.state.useragent;
        let href = this.getRedirect();
        if (ua.member && ua.member.MemberID) window.location.href = href;
    },

    computed: {},

    methods: {
        async submit() {
            console.clear();
            this.isValid = this.$refs.form.validate();
            if (!this.isValid) return;
            const dp = this.$store.dispatch;
            let text;
            this.spinner.visible = true;
            this.values.IP = await dp("loadIP");
            const res = await dp("authen/login", this.values);
            if (res.error) {
                text = res.error;
                this.spinner.visible = false;
                dp("views/snackbar/show", { text, color: "error" });
                return;
            }
            text = cafe.sms.success;
            dp("views/snackbar/show", { text, color: "success" });
            let href = this.getRedirect();
            window.location.href = href;
        },
        getRedirect() {
            const { getCookie } = this.$options.filters;
            let href = getCookie("login-redirect") || "https://core.es6.vn";
            href = decodeURIComponent(href);

            return href;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
::v-deep .v-input {
    flex: unset;
    min-width: 350px;
}
</style>



// WEBPACK FOOTER //
// login.vue